// Time Slot Typenames
export var ASAP = 'AsSoonAsPossible';
export var CANCELED_TIME = 'CancelledTime';
export var SPECIFIC_TIME = 'SpecificTime';
export var SUGGESTED = 'Suggested';
export var CONFIRMED = 'Confirmed';
export var PENDING = 'Pending';
export var TIME_BLOCK = 'TimeBlock';
// Misc
export var WEEK = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];
